import * as React from 'react';
import { Button, Modal, Container, Input } from '../../../Components';
import styled from 'styled-components';
import { ValidationError } from '../../../Store';

interface IModalProps {
  isOpen: boolean;
  outterClick: (() => void);
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  dia: string;
  hora: string;
  editarAgendamento: () => void;
  conviteAceito: boolean;
  validation: ValidationError<{ dataHora: string }>;
}

const StyledModal = styled(Modal)`
    font-family: Roboto,sans-seriff;
    height: fit-content;
    min-height: 200px;
`;

const ContainerGrid = styled(Container)`
  grid-template-columns: repeat(12, 1fr);
  padding-left: 30px;
`;

const StyledTitle = styled.span`
    font-size: 20px;
    padding: 10px 0px 0px 0px;
    font-weight: 500;
    grid-column: 1/13;
`;

const StyledSubTitle = styled.span`
    color: gray;
    font-size: 13px;
    padding: 5px 5px 20px 0px;
    grid-column: 1/13;
`;
const InputGrid = styled(Input) <any>`
    background-color: transparent;
    margin: 0;
    margin-right: 15px;
`;

const ButtonGrid = styled(Button)`
    grid-column: 1/13;
    justify-self: flex-end;
`;

export const EditarAgendamentoModal: React.FC<IModalProps> = (props: IModalProps) => {
  const { isOpen, outterClick, dia, hora, handleChange, editarAgendamento, conviteAceito, validation } = props;

  return (
    <StyledModal
      size='medium'
      outterClick={outterClick}
      isVisible={isOpen}
    >
      <ContainerGrid>
        <StyledTitle>Editar Agendamento </StyledTitle>
        {conviteAceito ?
          <StyledSubTitle>
            Não é possível alterar o agendamento, pois o convite já foi aceito pelo convidado. 
            Caso realmente for necessário, solicitar a alteração pelo Nuprajur.
          </StyledSubTitle>
          :
          <>
            <StyledSubTitle>Informe a nova data:</StyledSubTitle>
            <InputGrid
              gridColumn='1/4'
              label='Data:'
              type='date'
              value={dia}
              onChange={handleChange}
              name='dia'
              hasError={validation && validation.dataHora}
              errorMessage={validation && validation.dataHora}
            />
            <InputGrid
              gridColumn='4/6'
              label='Horário:'
              type='hora'
              placeholder='00:00'
              value={hora}
              onChange={handleChange}
              mask='99:99'
              name='hora'
              hasError={validation && validation.dataHora && validation.dataHora[0]}
            />
            <ButtonGrid
              type='submit'
              color='approvedColor'
              onClick={editarAgendamento}
            >
              SALVAR
            </ButtonGrid>
          </>
        }
      </ContainerGrid>
    </StyledModal>
  );
};
